import { render, staticRenderFns } from "./App.vue?vue&type=template&id=5456b618"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"
import style0 from "@/components/vue-notification/vue-notification.scss?vue&type=style&index=0&prod&lang=scss&external"
import style1 from "@/assets/styles/style.scss?vue&type=style&index=1&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports